import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTearSheet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 128 128",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinejoin: "round",
		strokeMiterlimit: 2
	},
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.746684,0,-0.384377,0.746684,41.5131,14.6702)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: 9.586,
			y: 11.549,
			width: 109.076,
			height: 109.032
		})
	}), /* @__PURE__ */ _jsx("g", {
		transform: "matrix(1,0,0,1,24,0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M41.444,21.804C42.266,20.21 44.228,19.583 45.822,20.406C47.416,21.228 48.042,23.19 47.22,24.784L45.47,28.176C44.647,29.77 42.685,30.397 41.091,29.574C39.497,28.752 38.871,26.79 39.693,25.196L41.444,21.804ZM29.191,45.549C30.013,43.955 31.975,43.328 33.569,44.151C35.163,44.973 35.79,46.935 34.967,48.529L31.467,55.314C30.644,56.908 28.682,57.534 27.088,56.712C25.494,55.889 24.868,53.927 25.69,52.333L29.191,45.549ZM15.188,72.686C16.01,71.092 17.972,70.466 19.566,71.288C21.16,72.111 21.787,74.073 20.964,75.667L17.463,82.451C16.641,84.045 14.679,84.672 13.085,83.849C11.491,83.026 10.865,81.065 11.687,79.471L15.188,72.686ZM1.185,99.824C2.007,98.23 3.969,97.603 5.563,98.426C7.157,99.248 7.784,101.21 6.961,102.804L5.211,106.196C4.388,107.79 2.426,108.417 0.832,107.594C-0.762,106.772 -1.388,104.81 -0.566,103.216L1.185,99.824Z",
			style: { fill: "white" }
		})
	})]
});
export default SvgTearSheet;
